import { render, staticRenderFns } from "./GraficoAusencia.vue?vue&type=template&id=082c6034&scoped=true&"
import script from "./GraficoAusencia.vue?vue&type=script&lang=js&"
export * from "./GraficoAusencia.vue?vue&type=script&lang=js&"
import style0 from "./GraficoAusencia.vue?vue&type=style&index=0&id=082c6034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c6034",
  null
  
)

export default component.exports